export enum GENDER {
  MALE = 'male',
  FEMALE = 'female',
  TRANS = 'trans',
  TRANSGENDER = 'transgender',
  SHEMALE = 'shemale',
  COUPLE = 'couple',
  DEFAULT = 'default',
  UNKNOWN = 'unknown',
  ALL = 'all',
}

export enum GENDER_HASH {
  MALE = 'cNXv44',
  FEMALE = 'uyvv9Z',
  SHEMALE = '4GkfR6',
  COUPLE = 'MHEYRS',
  ALL = 'gt15L2',
}

export const SEXUAL_ORIENTATION = {
  STRAIGHT: 'Straight',
  GAY: 'Gay',
  BISEXUAL: 'Bisexual',
  BICURIOUS: 'Bicurious',
};

export const NOTIFICATION_TYPE_PROFILE = {
  FRIEND_ACCEPTED: 'FRIEND_ACCEPTED',
  SCHEDULED_SHOWS: 'SCHEDULED_SHOWS',
  FANCLUB_PRIVATE_SHOWS: 'FANCLUB_PRIVATE_SHOWS',
};

export const ENUM_USER_TYPE = {
  PERFORMER: 'PERFORMER',
  ADMIN: 'ADMIN',
  STUDIO_OWNER: 'STUDIO_OWNER',
  STUDIO_ADMIN: 'STUDIO_ADMIN',
  STUDIO_PERFORMER: 'STUDIO_PERFORMER',
};

export enum ENUM_IDENTITY_STATUS {
  NO_IDENTITY = 'NO_IDENTITY',
  APPROVED = 'APPROVED',
  PENDING = 'PENDING_APPROVAL',
  REJECTED = 'REJECTED',
  ERROR = 'ERROR',
  NO_STATUS = 'NO_STATUS',
}

export const IDENTITY_FORM_STATUS = {
  READY: 'READY',
  START: 'START',
  ID: 'ID',
  LOADING: 'LOADING',
  CAPTURE: 'CAPTURE',
  DONE: 'DONE',
  EDIT: 'EDIT',
  ERROR: 'ERROR',
  ERROR_IDENTITY: 'ERROR_IDENTITY',
  ERROR_ID: 'ERROR_ID',
  ERROR_CAPTURE: 'ERROR_CAPTURE',
  NEW_IDENTITY: 'NEW_IDENTITY',
  EDIT_IDENTITY: 'EDIT_IDENTITY',
  NO_STATUS: 'NO_STATUS',
  EXIT: 'EXIT',
  IDENTITY_TYPE_MAIN: 'MAIN',
};

export const ENUM_FAVOURITE_STATUS = {
  NOT_FAVORITE: 'NOT_FAVORITE',
  FAVORITE: 'FAVORITE',
};

export const ENUM_FRIEND_STATUS = {
  NONE: 'NONE',
  PENDING: 'PENDING',
  ACCEPTED: 'ACCEPTED',
};

export const ENUM_STUDIO_STATUS = {
  UNCONFIRMED: 'UNCONFIRMED',
  DECLINED: 'DECLINED',
  CONFIRMED: 'CONFIRMED',
  PENDING: 'PENDING',
  PENDING_ID_VERIFICATION: 'PENDING_ID_VERIFICATION',
  REJECTED: 'REJECTED',
  APPROVED: 'APPROVED',
  ACCEPTED: 'ACCEPTED',
  ERROR: 'ERROR',
  NO_STATUS: 'NO_STATUS',
};

export const ENUM_TWO_FA = {
  VALIDATION_REQUIRED: 'VALIDATION_REQUIRED',
  INVALID_CODE: 'INVALID_CODE',
  PAID: 'PAID',
  PENDING: 'PENDING',
  CHANGE_PHONE_NUMBER: 'changePhoneNumber',
  CONFIG_EMAIL_2FA: 'configEmail2FA',
  VALIDATE: 'validate',
  FAILED: 'FAILED',
  SUCCESS: 'SUCCESS',
  RESEND_TWO_FA_CODE: 'resendTwoFaCode',
  DISABLE_TWO_FA: 'disableTwoFa',
  DISABLE_2FA: 'DISABLE_2FA',
  invalidPassword: 'invalidPassword',
  INVALID_PHONE_NUMBER: 'INVALID_PHONE_NUMBER',
  OPERATION_NOT_FOUND: 'OPERATION_NOT_FOUND',
  INTERNAL_SERVER_ERROR: 'INTERNAL_SERVER_ERROR',
  PAYMENT_SUBMIT: 'PAYMENT_SUBMIT',
  SETUP_SUBMIT: 'SETUP_SUBMIT',
  PAYMENT_RESEND_CODE: 'PAYMENT_RESEND_CODE',
  SETUP_RESEND: 'SETUP_RESEND',
  FORGOT_PASSWORD_SUBMIT: 'PASSWORD_SUBMIT',
  FORGOT_PASSWORD_RESEND: 'PASSWORD_RESEND',
  CHANGE_EMAIL_SUBMIT: 'CHANGE_EMAIL_SUBMIT',
  CHANGE_PASSWORD_SUBMIT: 'CHANGE_PASSWORD_SUBMIT',
  CHANGE_PASSWORD_RESEND: 'CHANGE_PASSWORD_RESEND',
  VERIFICATION_NOT_FOUND: 'VERIFICATION_NOT_FOUND',
  EMAIL: 'EMAIL',
  SMS: 'SMS',
  TWILIO_VERIFY: 'TWILIO_VERIFY',
  LIMIT_REACHED: 'LIMIT_REACHED',
};

export const OP_STATUS = {
  FAILED: 'FAILED',
  ERROR: 'ERROR',
  SUCCESS: 'SUCCESS',
  INVALID_CODE: 'INVALID_CODE',
  VALIDATION_REQUIRED: 'VALIDATION_REQUIRED',
  INTERNAL_SERVER_ERROR: 'INTERNAL_SERVER_ERROR',
};

export const FANCLUB_STATUS = {
  APPROVED: 'APPROVED',
  ACTIVATED: 'ACTIVATED',
  DEACTIVATED: 'DEACTIVATED',
  LOCKED: 'LOCKED',
};

export const IDENTITY_COMPLETION_STATUS = {
  COMPLETE: 'COMPLETE',
  INCOMPLETE: 'INCOMPLETE',
};

export const PROFILE_INFO_FILTERS = {
  bodyTypes: 'bodyTypes',
  maleBodyTypes: 'maleBodyTypes',
  femaleBodyTypes: 'femaleBodyTypes',
  classification: 'classification',
  breastSizes: 'breastSizes',
  transBreastSizes: 'transBreastSizes',
  maleRoles: 'maleRoles',
  penisSizes: 'penisSizes',
  penisTypes: 'penisTypes',
  transPenisTypes: 'transPenisTypes',
  transPenisSizes: 'transPenisSizes',
  maleTypes: 'maleTypes',
  femaleTypes: 'femaleTypes',
  transTypes: 'transTypes',
  transBodyTypes: 'transBodyTypes',
};

export const ENUM_PRIVATE_SPY_SHOWS = {
  PRIVATE_PAY_BY_MINUTE: 'PAY_BY_MINUTE',
  PRIVATE_BLOCK_OF_TIME: 'BLOCK_OF_TIME',
  SPY: 'SPY',
};

export const PARSED_PASSWORD_STRENGTH_INCREASED =
  // eslint-disable-next-line max-len
  ['true', 'false'].includes(window.PASSWORD_STRENGTH_INCREASED) ? JSON.parse(window.PASSWORD_STRENGTH_INCREASED) : false;

export const PARSED_UI_TRACE_ERRORS =
  window.UI_TRACE_ERRORS === 'true' || window.UI_TRACE_ERRORS === 'false' ? JSON.parse(window.UI_TRACE_ERRORS) : false;

export const ENUM_USER_CONSENT = {
  PROMOTIONS: 'PROMOTIONS',
  APPROVED: 'APPROVED',
  DENIED: 'DENIED',
  UNCONFIRMED: 'UNCONFIRMED',
  SEXUAL_PROFILING: 'SEXUAL_PROFILING',
  COOKIES: 'COOKIES',
  PERFORMER: 'PERFORMER',
  ALL: 'all',
};

export const HEIGHT_UNIT = {
  IMPERIAL: 'imperial',
  METRIC: 'metric',
};

export const IMPERSONATE_KEY = 'impersonate-user';

export const USER_NOT_FOUND = 'user_not_found';

export const GENDER_COOKIE = {
  MALE: 'cNXv44',
  FEMALE: 'uyvv9Z',
  TRANSGENDER: '4GkfR6',
  COUPLE: 'MHEYRS',
  ALL: 'gt15L2',
};

export const CHECK_ROOM_STATUS_CHANGE_FROM_PRIVATE_ROOM = 8000;

export const CASHOUT_STATUS = {
  NONE: 'NONE',
  BROADCAST_APPROVED: 'BROADCAST_APPROVED',
  APPROVED_2257: 'APPROVED_2257',
  CASH_OUT_APPROVED: 'CASH_OUT_APPROVED',
};

export const IDENTITY_TYPE = { MAIN: 'Main' };

export const IDENTITY_TYPE_FILTERS = {
  ALL: 'ALL',
  MAIN: 'MAIN',
  OTHERS: 'OTHERS',
};

export const ADMIN_ONBOARDING_SECTION_TYPE = {
  REGULAR_PERFORMERS: 'REGULAR_PERFORMERS',
  STUDIO_OWNERS_AND_ADMINS: 'STUDIO_OWNERS_AND_ADMINS',
  STUDIO_PERFORMERS: 'STUDIO_PERFORMERS',
};

export const ROOM_MODE = {
  PUBLIC: 'Public',
  PRIVATE: 'Private',
};

export const RES_ERROR_CODES = [
  ENUM_TWO_FA.INTERNAL_SERVER_ERROR,
  'authError',
  ENUM_TWO_FA.invalidPassword,
  ENUM_TWO_FA.FAILED,
  ENUM_TWO_FA.VERIFICATION_NOT_FOUND,
];
